import axios from 'axios';
import React, { useState, useEffect, Fragment } from 'react';
import { API_AUTH, URL_DEFAULT, URL_LOGIN, AUTH_ORIGEN, AVAILABLE_APPS } from '../../config/config';
import { useDispatch } from 'react-redux';
import { CUTest, CULogIn, CULogOut } from '../../redux/actions/ClaveUnicaActions';
import { Box, CircularProgress, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { validacionApps } from '../../services/service.user';

import { useHistory } from 'react-router-dom';
// import { ContactSupportOutlined } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  circularProgressRoot: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 999999,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const Reception = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const code = params.get('code');
  const state = params.get('state');
  const [error, setError] = useState(false);
  const [msgError, setMsgError] = useState('');
  let history = useHistory();

  const dispatch = useDispatch();
  const classes = useStyles();
  dispatch(CUTest());

  const closeError = () => {
    setError(false);
    setMsgError('');
  };

  useEffect(() => {
    const retornarIni = (msg = '') => {
      setError(true);
      setMsgError(msg);
      setTimeout(() => {
        history.push(URL_LOGIN);
      }, 5000);
    };

    if (code && state) {
      axios
        .post(`${API_AUTH}checkstate/${AUTH_ORIGEN}`, { code, state })
        .then(res => {
          axios
            .get(`${API_AUTH}user/me/info`, {
              headers: { Authorization: `Bearer ${res.data.token}` },
            })
            .then(res2 => {
              // realizar validacion por applicaciones
              if (validacionApps(AVAILABLE_APPS, res2.data)) {
                var user = res2.data;
                user.token = res.data.token;
                dispatch(CULogIn(user));
                history.push(URL_DEFAULT);
              } else {
                dispatch(CULogOut());
                retornarIni('Usuario sin autorizacion');
              }
            })
            .catch(err2 => {
              console.log('er1', err2);
              dispatch(CULogOut());
              if (err2.response.data.detail === 'User not active') {
                retornarIni('Usuario deshabilitado');
              } else {
                retornarIni('Ocurrió un error al buscar los datos del usuario');
              }
            });
        })
        .catch(err => {
          console.log('err2', err);
          dispatch(CULogOut());
          retornarIni('Ocurrió un error al buscar los datos del usuario');
        });
    }
  }, [dispatch, history, state, code]);

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={error}
        onClose={closeError}
        autoHideDuration={6000}>
        <MuiAlert elevation={6} variant="filled" onClose={closeError} severity="error">
          {msgError}
        </MuiAlert>
      </Snackbar>
      <Box className={classes.circularProgressRoot}>
        <CircularProgress />
      </Box>
    </Fragment>
  );
};

export default Reception;
